import { Space, Typography, Dropdown, Avatar } from "antd";
import { 
  MenuOutlined, 
  UserOutlined, 
  SettingOutlined, 
  LogoutOutlined,
  AppstoreOutlined,
  PieChartOutlined,
  PlusCircleOutlined,
  DatabaseOutlined,
  CloudServerOutlined,
  ClusterOutlined,
  DownOutlined
} from "@ant-design/icons";
import { signOut } from "@aws-amplify/auth";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import * as storage from "../../helpers/roborpoc_storage";

const { Text } = Typography;

const AppHeader = () => {
  const [userID, setuserID] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setuserID(storage.get("user.isid", ""));
  }, []);

  const getInitials = (id) => {
    if (!id) return "U";
    return id.substring(0, 2).toUpperCase();
  };

  const menuItems = [
    {
      key: "/",
      icon: <AppstoreOutlined />,
      label: "Admin Dashboard",
    },
    {
      key: "/dashboard",
      icon: <PieChartOutlined />,
      label: "Management Dashboard",
    },
    {
      key: "/cluster/initialize",
      icon: <PlusCircleOutlined />,
      label: "New Order",
    },
    {
      key: "/sizing",
      icon: <DatabaseOutlined />,
      label: "Sizing",
    },
    {
      key: "/commvault",
      icon: <CloudServerOutlined />,
      label: "Commvault",
    },
    {
      key: "/cluster-info",
      icon: <ClusterOutlined />,
      label: "Cluster Info",
    },
  ];

  const userMenuItems = [
    {
      key: "user-info",
      label: (
        <div style={{ padding: "8px 0", borderBottom: "1px solid #E5E7EB" }}>
          <Text strong style={{ display: "block", color: "#111827" }}>
            {userID || "User"}
          </Text>
          <Text style={{ fontSize: "12px", color: "#6B7280" }}>
            Logged in user
          </Text>
        </div>
      ),
      disabled: true,
    },
    {
      key: "settings",
      icon: <SettingOutlined />,
      label: "Settings",
    },
    {
      type: "divider",
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Sign out",
      danger: true,
      onClick: signOut,
    },
  ];

  const handleMenuClick = (e) => {
    if (e.key && e.key !== "user-info") {
      navigate(e.key);
    }
  };

  // Get current page label
  const getCurrentPageLabel = () => {
    const currentItem = menuItems.find(item => item.key === location.pathname);
    return currentItem ? currentItem.label : "Menu";
  };

  return (
    <header className="app-header">
      {/* Single Teal Header Bar */}
      <div className="header-brand" style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 24px",
        height: "60px",
        background: "linear-gradient(135deg, #00857C 0%, #005249 100%)",
      }}>
        {/* Left Section: Logo + Title */}
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <img 
            src="/images/logo.png" 
            alt="Merck Logo" 
            className="header-brand-logo"
            style={{ height: "36px", width: "auto" }}
          />
          <div>
            <h1 className="header-brand-title" style={{ 
              margin: 0, 
              fontSize: "18px", 
              fontWeight: 700,
              color: "white",
              letterSpacing: "-0.025em"
            }}>
              ROBO Order Platform
            </h1>
            <p className="header-brand-subtitle" style={{ 
              margin: 0, 
              fontSize: "11px", 
              color: "rgba(255,255,255,0.75)",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              fontWeight: 500
            }}>
              Infrastructure Procurement System
            </p>
          </div>
        </div>

        {/* Right Section: Menu Dropdown + User */}
        <Space size={20}>
          {/* Navigation Menu Dropdown */}
          <Dropdown
            menu={{ 
              items: menuItems,
              onClick: handleMenuClick,
              selectedKeys: [location.pathname]
            }}
            trigger={["click"]}
            placement="bottomLeft"
          >
            <div 
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "8px 16px",
                borderRadius: "6px",
                cursor: "pointer",
                background: "rgba(255,255,255,0.15)",
                border: "1px solid rgba(255,255,255,0.25)",
                transition: "all 0.15s ease"
              }}
            >
              <MenuOutlined style={{ fontSize: "14px", color: "white" }} />
              <Text style={{ 
                fontWeight: 500, 
                color: "white",
                fontSize: "14px"
              }}>
                {getCurrentPageLabel()}
              </Text>
              <DownOutlined style={{ fontSize: "10px", color: "rgba(255,255,255,0.75)" }} />
            </div>
          </Dropdown>

          {/* User Dropdown */}
          <Dropdown
            menu={{ items: userMenuItems }}
            trigger={["click"]}
            placement="bottomRight"
          >
            <div 
              className="header-user-menu"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "6px 12px",
                borderRadius: "6px",
                cursor: "pointer",
                transition: "all 0.15s ease",
                background: "rgba(255,255,255,0.15)",
                border: "1px solid rgba(255,255,255,0.25)"
              }}
            >
              <Avatar 
                size={28}
                style={{ 
                  background: "white",
                  color: "#00857C",
                  fontSize: "12px",
                  fontWeight: 600
                }}
              >
                {getInitials(userID)}
              </Avatar>
              <Text style={{ 
                fontWeight: 500, 
                color: "white",
                fontSize: "14px"
              }}>
                {userID || "User"}
              </Text>
              <DownOutlined style={{ fontSize: "10px", color: "rgba(255,255,255,0.75)" }} />
            </div>
          </Dropdown>
        </Space>
      </div>
    </header>
  );
};

export default AppHeader;
